<template>
    <v-dialog v-model="mostrar" persistent max-width="500px">
        <v-card :loading="loading">
            <v-card-title>
            <span class="headline">Asignar integrante</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-autocomplete
                                label="Usuarios:"
                                :items="usuarios"
                                return-object
                                item-text="nombreCompleto"
                                v-model="usuarioSel"
                                :filter="customFilter"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field 
                                v-model="puesto" 
                                name="SG-ND-puesto" 
                                label="Puesto:"
                                :error-messages="errors.puesto"
                                @input="validarPuesto()"
                                @blur="validarPuesto()"
                                >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue-grey darken-1" outlined text @click="$emit('cancelar')">Cancelar</v-btn>
            <v-btn color="blue-grey darken-1" dark :disabled="usuarioSel == null" @click="guardarIntegrante()">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
       
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'
import axios from 'axios'
import { mapGetters} from 'vuex'
import _ from 'underscore'

export default {
    props:['mostrar','dependencia'],
    mixins: [validationMixin],
    data: () => ({
        loading: false,
        usuarios: [],
        usuarioSel: null,
        puesto: null,
        errors:{
            puesto: [],
        },
    }),
    validations: {
        puesto: { required, minLength: minLength(5) }
    },
    computed: {
        ...mapGetters([
            "httpURL",
            "sessionToken"
        ])
    },
    created(){
        // console.log(this.dependencia);
        this.loading = true;
        axios.get(this.httpURL+'/dependencia/integrantes/disponibles/'+this.dependencia,
            {headers:{token:this.sessionToken}})
            .then(res => {
                if( res.data.ok ){
                    this.usuarios = res.data.usuarios;
                    this.loading = false;
                }else{
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                    this.loading = false;
                }
            })
            .catch(error => {
                // console.log('Error: '+error);
                this.loading = false;
                this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
            });
    },
    methods: {
        validarPuesto(){
            this.$v.puesto.$touch();
            const errors = []
            if (this.$v.puesto.$dirty){
                !this.$v.puesto.required && errors.push('Campo requerido.');
                !this.$v.puesto.minLength && errors.push('Mínimo 5 caracteres.');
            }
            this.errors.puesto = errors;
        },
        guardarIntegrante(){
            this.$v.$touch();
            this.validarPuesto();
            if (!this.$v.$invalid) {
                this.loading = true;
                axios.post(this.httpURL+'/dependencia/integrantes/'+this.dependencia,
                { usuario: this.usuarioSel._id, puesto: this.puesto },
                {headers:{token:this.sessionToken}})
                .then(res => {
                    if( res.data.ok ){
                        this.$emit('usuarioAgregado',{integrantes:res.data.integrantes, log:res.data.log});
                        this.loading = false;
                        this.$notify({ group: 'gral_notif', type:"succsess", duration:1500, speed: 500, text: res.data.mensaje });
                    }else{
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                        this.loading = false;
                    }
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.loading = false;
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                });
            }
        },
        normalizarTexto(texto) {
            if (!texto) return ""; // Manejar valores nulos o vacíos
            return texto
                .normalize("NFD") // Divide caracteres acentuados
                .replace(/[\u0300-\u036f]/g, "") // Elimina marcas diacríticas
                .toLowerCase(); // Convierte a minúsculas
        },
        // Filtro personalizado para manejar búsqueda insensible a acentos
        customFilter(item, queryText, itemText) {
            // Normaliza el texto ingresado y el texto del ítem
            const textoBusquedaNormalizado = this.normalizarTexto(queryText);
            const textoItemNormalizado = this.normalizarTexto(itemText);

            // Realiza la comparación
            return textoItemNormalizado.includes(textoBusquedaNormalizado);
        },

    }
}
</script>